<template>
  <div class="mainbody">
    <div style="height:0.1px"></div>

    <!-- 视频标题 -->
    <div id="VideoHeaderDiv">
      <div class="videotitle">{{Data.title_cn}}</div>
    </div>

    <!-- 视频简介 -->
    <div class="textDiv" v-if="Data.description || Data.parent_guide">
        <div id="description" class="maintext" v-html="addDiv(Data.description || Data.parent_guide)"></div>
    </div>

    <!-- 视频推荐理由 -->
    <div v-if="Data.recommend_reason">
      <div id="headerdiv">
        <div class="headertitle">{{ lang.recommend_reason }}</div>
      </div>
      <div class="maintext" id="recommend_reason">{{Data.recommend_reason}}</div>
    </div>

    <!-- 动画片 -->
      <div v-if="Data.video_link">
        <div id="headerdiv">
          <div class="headertitle">{{ lang.video }}</div>
        </div>
        <div class="flex-row-center">
          <iframe id="video_link" class="video_iframe" style="z-index:1;"
            :src="Data.video_link" allowfullscreen="" frameborder="0"
            :width="MAXWIDTH"
            :height="MAXHEIGHT"
            ></iframe>
        </div>
      </div>
</div>

<!-- <div class="flex-center flex-column">
  <div class="section section-desc">
      <div class="section-title flex-row-center" id="title">{{Data.title_cn}}</div>
      <div id="description" class="flex-row-center" v-html="addDiv(Data.description || Data.parent_guide)"></div>
  </div>

  <div class="section section-recommend" v-if="Data.recommend_reason">
      <div class="section-title flex-row-center">推荐理由</div>
      <div id="recommend_reason" class="flex-row-center">{{Data.recommend_reason}}</div>
  </div>

    <div class="section section-video">
        <div class="section-title flex-row-center">动画视频</div>
        <div class="flex-row-center">
          <iframe id="video_link" class="video_iframe" style="z-index:1;" :src="Data.video_link" allowfullscreen="" frameborder="0"
          :width="MAXWIDTH"
          :height="MAXHEIGHT"
          ></iframe>
        </div>
    </div>
</div> -->

</template>

<script>
import BaseVue from '@/components/BaseVue'

export default {
  name: 'VideoTemplate',
  extends: BaseVue,
  data () {
    return {
      Data: Object()
    }
  },
  created: async function(){
    let data_id = this.$route.params.id
    let url = this.GATEWAY_ORIGINAL + 'bigdata/cej_target/query_video_info?id=' + data_id
    console.log('url: ' + url)
    let that = this;
    await this.getLang()
    document.title = this.lang.VideoTemplateTitle
    this.queryData(url, function (data) {
      that.Data = data
      if (that.Data.video_link){
        that.Data.video_link = that.resetVideoSize(that.Data.video_link)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/resource/Video.vue